import React from 'react';
import './ManufacturingIntro.css';
import manufacturingImg from '../../assets/images/manufacturing.jpeg'; // Import image

const ManufacturingIntro = () => {
  return (
    <section className="manufacturing-intro-section">
      <div className="container">
        <div className="manufacturing-intro-grid">
          <div className="manufacturing-image-container">
            <img 
              src={manufacturingImg} // Use imported image
              alt="Manufacturing" 
              className="manufacturing-image"
            />
          </div>
          <div className="manufacturing-text-content">
            <h2 className="manufacturing-title">Why Choose NeuroverseAI?</h2>
            <p>
              Neuroverse AI offers comprehensive SAP consulting services tailored to the manufacturing industry in both the UAE and the USA. Our expertise includes SAP migration and upgrade services, ensuring seamless transitions to advanced SAP platforms. We specialize in SAP implementation for manufacturing industries, providing customized solutions to meet specific business needs. Our SAP system upgrade solutions enhance operational efficiency and performance. We deliver SAP enterprise solutions designed to drive business transformation and growth. Our consulting services focus on facilitating business transformation, leveraging SAP technologies to optimize processes and achieve strategic objectives.
            </p>
            <div className="features-list">
              <div className="feature-item">
                <img src="https://avas.live/artificial-intelligence/wp-content/uploads/sites/71/2023/09/solutions-1.png" alt="Icon" />
                <h4>Performance Controlling</h4>
              </div>
              <div className="feature-item">
                <img src="https://avas.live/artificial-intelligence/wp-content/uploads/sites/71/2023/09/certified-expert-1.png" alt="Icon" />
                <h4>Raw Material Controlling</h4>
              </div>
              <div className="feature-item">
                <img src="https://avas.live/artificial-intelligence/wp-content/uploads/sites/71/2023/09/247support-1.png" alt="Icon" />
                <h4>Cost Accounting</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManufacturingIntro;
